import React from 'react';
import {
  FaCreditCard,
  FaLaptopCode,
  FaMoneyCheckAlt,
  FaProjectDiagram,
  FaShieldAlt,
  FaUserPlus,
} from 'react-icons/fa';

const solutions = [
  {
    title: 'Workflow engineering',
    Icon: FaProjectDiagram,
    description:
      'Replace repetitive manual tasks with scheduled, error-free syncs between your CRM, spreadsheets, email, and Slack—so teams stop re-keying data and losing handoffs.',
    stack: 'n8n, webhooks, Google Workspace, HubSpot, Slack',
  },
  {
    title: 'Accounts receivable & billing follow-up',
    Icon: FaMoneyCheckAlt,
    description:
      'Automated reminders and status updates that run on a daily cadence—so finance does not chase invoices by hand; every touch is logged.',
    stack: 'Sheets, Gmail, scheduled runs, routing rules',
  },
  {
    title: 'Lead intake & nurture',
    Icon: FaUserPlus,
    description:
      'From first click to qualified lead: capture, qualify, route to sales, and trigger follow-up sequences without manual CRM copy-paste.',
    stack: 'Webhooks, HubSpot, Slack, timed email sequences',
  },
  {
    title: 'Product & platform delivery',
    Icon: FaLaptopCode,
    description:
      'Ship reliable web apps and internal tools—structured workflows, RBAC, and integrations—when the outcome is a product, not just a brochure.',
    stack: 'Ruby on Rails, Next.js, PostgreSQL, Stripe',
  },
  {
    title: 'Payments & subscriptions',
    Icon: FaCreditCard,
    description:
      'Stripe-backed checkout and billing flows so revenue and access stay aligned with your product rules.',
    stack: 'Stripe, Rails, webhooks',
  },
  {
    title: 'Quality & maintainability',
    Icon: FaShieldAlt,
    description:
      'Automated tests and clear boundaries so workflows and apps stay safe to change as your business grows.',
    stack: 'Jest, CI-friendly patterns',
  },
];

const Skills = () => {
  return (
    <div
      name='solutions'
      className='w-full bg-white text-gray-900 dark:bg-[#0a192f] dark:text-gray-300 py-24'
    >
      <div className='max-w-[1000px] mx-auto px-4 flex flex-col justify-center w-full'>
        <div className='pb-8'>
          <h2 className='text-5xl font-bold inline border-b-4 border-pink-600 text-gray-900 dark:text-gray-300'>
            Solutions
          </h2>
          <p className='py-4 text-gray-600 dark:text-[#8892b0] max-w-2xl'>
            Business pains addressed—not a laundry list of tools. Tech stacks are listed so technical buyers know what to
            expect.
          </p>
        </div>

        <div className='w-full grid sm:grid-cols-2 gap-6 py-4'>
          {solutions.map(({ Icon, ...item }) => (
            <div
              key={item.title}
              className='rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50/80 dark:bg-[#0f172a]/50 p-6 shadow-sm hover:border-pink-600/40 transition-colors'
            >
              <div className='flex items-start gap-3'>
                <span className='mt-1 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-pink-600/10 text-pink-600 dark:text-pink-400'>
                  <Icon className='text-xl' aria-hidden />
                </span>
                <div>
                  <h3 className='text-lg font-semibold text-gray-900 dark:text-[#ccd6f6]'>{item.title}</h3>
                  <p className='mt-2 text-sm leading-relaxed text-gray-700 dark:text-gray-300'>{item.description}</p>
                  <p className='mt-3 text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-500'>
                    Typical stack: {item.stack}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Skills;
